// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IQaGetListAttrs, IQaGetDetailAttrs, IQaDeleteAttrs } from 'interfaces/back-office/qa/qa-view.interface'

const useQa = () => {
  // Hook
  const {
    qa: {
      qa_loading,
      qa_list,
      qa_detail,
      qa_CLEAR_LIST,
      qa_CLEAR_DETAIL,
      qa_fetchList: fetchList,
      qa_fetchDetail: fetchDetail,
      qa_delete: _delete,
    },
  } = useStores()

  /**
   * @description Fetch qa list
   *
   * @param {IQaGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const qa_fetchList = useCallback(
    async (payload: IQaGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Fetch qa detail
   *
   * @param {IQaGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const qa_fetchDetail = useCallback(
    async (payload: IQaGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Delete qa
   *
   * @param {IQaDeleteAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const qa_delete = useCallback(
    async (payload: IQaDeleteAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        _delete({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [_delete],
  )

  return {
    qa_loading,
    qa_list,
    qa_detail,
    qa_CLEAR_LIST,
    qa_CLEAR_DETAIL,
    qa_fetchList,
    qa_fetchDetail,
    qa_delete,
  }
}

export { useQa }
